import { getFiles } from '@/API/repositories/file';
import { FILE_TYPES } from '@/common/constants/fileTypes';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useEffect, useRef, useState } from 'react';

const useDocsPopUp = ({ setShow, handleSubmit }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const isLoading = hasUnfilledRequest(getFiles);

	const [fileOptions, setFileOptions] = useState([]);
	const [selectedAttachments, setSelectedAttachments] = useState([]);
	const [selectedDocuments, setSelectedDocuments] = useState([]);
	const [includeQuestionnaireParagraph, setIncludeQuestionnaireParagraph] =
		useState(false);
	const startDateRef = useRef();
	const deadlineRef = useRef();

	const fetchFiles = async () => {
		const response = await makeRequest(() => getFiles(FILE_TYPES.CC));

		if (!response?.data) {
			return addMessage("Couldn't load call center positions", 'error');
		}

		setFileOptions(
			response.data.map(({ filename, info, _id }) => ({
				label: `${info ?? ''} ${filename}`.trim(),
				value: _id,
			})),
		);
	};

	const onSubmit = (e) => {
		e.preventDefault();
		handleSubmit({
			files: selectedAttachments.map(
				(selectedFileName) => selectedFileName.value,
			),
			docs: selectedDocuments.map((selectedFileName) => selectedFileName.value),
			startDate: startDateRef.current.value,
			deadline: deadlineRef.current.value,
			includeQuestionnaireParagraph,
		});
		addMessage('Success', 'success');
		setShow(false);
	};

	useEffect(() => {
		fetchFiles();
	}, []);

	return {
		isLoading,
		onSubmit,
		fileOptions,
		setSelectedAttachments,
		selectedAttachments,
		setSelectedDocuments,
		selectedDocuments,
		startDateRef,
		deadlineRef,
		includeQuestionnaireParagraph,
		setIncludeQuestionnaireParagraph,
	};
};

export default useDocsPopUp;
